import {sensorModePlugin} from '../reports/plugin';

export default sensorModePlugin;
